module.exports = __webpack_public_path__ + "static/media/21-13.ab7e45a9.mp3";